import { SessionMetadataProvider } from "contexts/SessionMetadata";
import { BrowserRouter, Route, RouteProps, Routes } from "react-router-dom";
import { Slide, ToastContainer } from "react-toastify";
import { Capture } from "./pages/Capture";
import { Login } from "./pages/Login";
import { Home } from "pages/Home";
import { SignUp } from "./pages/Signup";
import { AppRoutes } from "types";
import { Orb } from "pages/Orb";
import { Logout } from "pages/Logout";
import { LoginOrSignup } from "pages/LoginOrSignup";
import { BatchUpload } from "pages/BacthUpload";
import { CollectionDetailsContextProvider } from "contexts/CollectionDetails";
import { UploadContextProvider } from "contexts/UploadContext";
import { AuthContextProvider } from "contexts/AuthContext";
import { IrisUpload } from "pages/IrisUpload";
import { DeletionRequest } from "pages/DeletionRequest";
import { PcrCapture } from "pages/PcrCapture";
import { TaskInstructions } from "pages/TaskInstructions";
import { StepCapture } from "pages/StepCapture";
import { QrCaptureStep, StepOrb } from "pages/StepOrb";
import { RtmsSequence } from "pages/RtmsSequence";
import { MultiStepUpload } from "pages/MultiStepUpload";
import { VideoUpload } from "pages/VideoUpload";
import { MultiStepCaptureProvider } from "contexts/MultiStepCaptureContext";
import { Welcome } from "pages/Welcome";
import { SetPassword } from "pages/SetPassword";

const routes: Array<RouteProps> = [
  {
    path: AppRoutes.home,
    index: true,
    element: <Home />,
  },
  {
    path: AppRoutes.loginOrSignup,
    element: <LoginOrSignup />,
  },
  {
    path: AppRoutes.login,
    element: <Login />,
  },
  {
    path: AppRoutes.signup,
    element: <SignUp />,
  },
  {
    path: AppRoutes.welcome,
    element: <Welcome />,
  },
  {
    path: AppRoutes.setPassword,
    element: <SetPassword />,
  },
  {
    path: AppRoutes.orb,
    element: <Orb />,
  },
  {
    path: AppRoutes.capture,
    element: <Capture />,
  },
  {
    path: AppRoutes.logout,
    element: <Logout />,
  },
  {
    path: AppRoutes.batchUpload,
    element: <BatchUpload />,
  },
  {
    path: AppRoutes.irisUpload,
    element: <IrisUpload />,
  },
  {
    path: AppRoutes.deletionRequest,
    element: <DeletionRequest />,
  },
  {
    path: AppRoutes.pcrCapture,
    element: <PcrCapture />,
  },
  {
    path: AppRoutes.taskInstructions,
    element: <TaskInstructions />,
  },
  {
    path: AppRoutes.stepCapture,
    element: <StepCapture />,
  },
  {
    path: AppRoutes.stepOrb,
    element: <StepOrb />,
  },
  {
    path: AppRoutes.stepRtms,
    element: <QrCaptureStep captureType="rtms" />,
  },
  {
    path: AppRoutes.rtmsSequence,
    element: <RtmsSequence />,
  },
  {
    path: AppRoutes.multiStepUpload,
    element: <MultiStepUpload />,
  },
  {
    path: AppRoutes.videoUpload,
    element: <VideoUpload />,
  },
];

export function App() {
  return (
    <BrowserRouter>
      <ToastContainer
        transition={Slide}
        position="top-center"
        limit={1}
        hideProgressBar
        autoClose={5000}
      />

      <div className="contents gt-phone:grid place-items-center w-screen h-screen items-center bg-black/10">
        <div className="contents overflow-hidden gt-phone:block gt-phone:rounded-3xl gt-phone:shadow-2xl bg-white max-w-[430px] max-h-[896px] w-full h-fill gt-phone:[clip-path:inset(0_round_24px)]">
          <AuthContextProvider>
            <CollectionDetailsContextProvider>
              <SessionMetadataProvider>
                <MultiStepCaptureProvider>
                  <UploadContextProvider>
                    <Routes>
                      {routes.map((route) => (
                        <Route {...route} key={route.path} />
                      ))}
                    </Routes>
                  </UploadContextProvider>
                </MultiStepCaptureProvider>
              </SessionMetadataProvider>
            </CollectionDetailsContextProvider>
          </AuthContextProvider>
        </div>
      </div>
    </BrowserRouter>
  );
}
